module.exports = __webpack_public_path__ + "img/videovigilancia.cad435bb.png";